import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FormaterFilstørrelsePipe} from "felles-ng2/pipes/FormaterFilstørrelsePipe";
import {MatButton} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {Valideringsresultat} from "felles-ng2/tjenester/filopplasting/SekvensiellFilopplasting";
import {Appkonfigurasjon} from "felles-ng2/tjenester/Appkonfigurasjon";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {Mimeinfo, tillatteMimetyper} from "felles-ng2/støttefunksjoner/mimetyper";
import {distinkte} from "felles-ng2/støttefunksjoner/lister";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";

const debug = initDebugger('DokumentOpplastingFeilKomponent');

/**
 * Viser valideringsfeil levert av {@link SekvensiellFilopplasting}
 */
@Component({
    selector: 'dokument-opplasting-feil-dialog',
    templateUrl: 'dokument-opplasting-feil-dialog.html',
    styleUrl: 'dokument-opplasting-feil-dialog.scss',
    imports: [
        FormaterFilstørrelsePipe,
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        TranslateModule,
        MatDialogClose,
        TipsKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentOpplastingFeilDialogKomponent {

    static visValideringsfeil(dialog: MatDialog, valideringsfeil: Valideringsresultat) {
        return dialog.open<DokumentOpplastingFeilDialogKomponent, DialogParametre, boolean>(DokumentOpplastingFeilDialogKomponent,
          {
              data: {valideringsfeil},
              panelClass: 'dokument-opplasting-feil-dialog',
              maxWidth: '500px'
          });
    }

    static visOpplastingsfeilUgyldigMimetype(dialog: MatDialog, filerMedUgyldigMimetype:FilMedUgyldigMimetype[]) {
        return dialog.open<DokumentOpplastingFeilDialogKomponent, DialogParametre, boolean>(DokumentOpplastingFeilDialogKomponent,
          {
              data: {filerMedUgyldigMimetype},
              panelClass: 'dokument-opplasting-feil-dialog',
              maxWidth: '500px'
          });
    }

    valideringsfeil?: Valideringsresultat; //settes via DialogParametre, en av valideringsfeil og filerMedUgyldigMimetype vil være satt
    filerMedUgyldigMimetype?: FilMedUgyldigMimetype[];//settes via DialogParametre, en av valideringsfeil og filerMedUgyldigMimetype vil være satt

    modus: 'valideringsfeil' | 'ugyldigMimetype' = 'valideringsfeil';
    tvilsomtOfficeFormat = false;
    maksFilstoerrelse: number;
    gyldigeFiltyper: Mimeinfo[];

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre, public dialogRef: MatDialogRef<DokumentOpplastingFeilDialogKomponent>, konfigurasjon: Appkonfigurasjon) {
        if (erIkkeNil(parametre.valideringsfeil)) {
            this.modus = 'valideringsfeil'
            this.valideringsfeil = parametre.valideringsfeil!;
        } else {
            this.modus = 'ugyldigMimetype'
            this.filerMedUgyldigMimetype = parametre.filerMedUgyldigMimetype!;
            this.tvilsomtOfficeFormat = this.filerMedUgyldigMimetype.some(ugyldig => ugyldig.mimetype == 'tika/office');
        }
        this.maksFilstoerrelse = konfigurasjon.maksFilopplastingStørrelse;
        this.gyldigeFiltyper = distinkte(tillatteMimetyper(), (a, b) => a.visningsnavn == b.visningsnavn);
    }
}

export type DialogParametre = {
    valideringsfeil?: Valideringsresultat;
    filerMedUgyldigMimetype?: FilMedUgyldigMimetype[];
}

export type FilMedUgyldigMimetype = { filnavn: string; mimetype: string; };
